import { useIntl } from 'react-intl';

export const useContractConstants = () => {
  const intl = useIntl();

  const purchaseIndexType = {
    K: 'K+',
    RI: 'RI',
    RP: 'RP',
    RIK: 'RI+K',
  };

  const priceSource = {
    SETTLEMENT: 'SETTLEMENT',
    BESTASK: 'BESTASK',
    BESTBID: 'BESTBID',
  };

  const labels = {
    addCoefficient: intl.formatMessage({ id: 'app.contractParameters.addCoefficient' }),
    referenceIndex: intl.formatMessage({ id: 'app.contractParameters.referenceIndex' }),
    basePrice: intl.formatMessage({ id: 'app.contractParameters.basePrice' }),
    referenceIndexAddCoeficient: intl.formatMessage({ id: 'app.contractParameters.referenceIndexAddCoeficient' }),
  };

  const labelSufix = {
    [priceSource.SETTLEMENT]: intl.formatMessage({ id: 'app.contractParameters.sufix.settlement' }),
    [priceSource.BESTASK]: intl.formatMessage({ id: 'app.contractParameters.sufix.bestAsk' }),
    [priceSource.BESTBID]: intl.formatMessage({ id: 'app.contractParameters.sufix.bestBid' }),
  };

  const tariffs = [
    {
      purchaseIndexType: purchaseIndexType.K,
      priceSource: priceSource.SETTLEMENT,
      label: `${labels.addCoefficient} ${labelSufix[priceSource.SETTLEMENT]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.K,
      priceSource: priceSource.BESTASK,
      label: `${labels.addCoefficient}  ${labelSufix[priceSource.BESTASK]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.K,
      priceSource: priceSource.BESTBID,
      label: `${labels.addCoefficient}  ${labelSufix[priceSource.BESTBID]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RI,
      priceSource: priceSource.SETTLEMENT,
      label: `${labels.referenceIndex} ${labelSufix[priceSource.SETTLEMENT]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RI,
      priceSource: priceSource.BESTASK,
      label: `${labels.referenceIndex} ${labelSufix[priceSource.BESTASK]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RI,
      priceSource: priceSource.BESTBID,
      label: `${labels.referenceIndex}  ${labelSufix[priceSource.BESTBID]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RP,
      priceSource: priceSource.SETTLEMENT,
      label: `${labels.basePrice} ${labelSufix[priceSource.SETTLEMENT]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RP,
      priceSource: priceSource.BESTASK,
      label: `${labels.basePrice} ${labelSufix[priceSource.BESTASK]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RP,
      priceSource: priceSource.BESTBID,
      label: `${labels.basePrice}  ${labelSufix[priceSource.BESTBID]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RIK,
      priceSource: priceSource.SETTLEMENT,
      label: `${labels.referenceIndexAddCoeficient} ${labelSufix[priceSource.SETTLEMENT]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RIK,
      priceSource: priceSource.BESTASK,
      label: `${labels.referenceIndexAddCoeficient} ${labelSufix[priceSource.BESTASK]}`,
      isVisibleInTable: false,
    },
    {
      purchaseIndexType: purchaseIndexType.RIK,
      priceSource: priceSource.BESTBID,
      label: `${labels.referenceIndexAddCoeficient}  ${labelSufix[priceSource.BESTBID]}`,
      isVisibleInTable: false,
    },
  ];

  return { labels, purchaseIndexType, priceSource, tariffs };
};

